<template>
  <div :disabled="disabled" @click="handleSubmit">
    <slot>{{label}}</slot>
    <i class="fa fa-spinner loading" v-show="submiting"></i>
  </div>
</template>

<script>
export default {
  name: 'SubmitButton',
  props: {
    label: String,
    valid: null,
    submit: Function,
    errors: Array,
  },
  data() {
    return  {
      submiting: false
    }
  },
  computed: {
    disabled() {
      return !this.valid
    },
  },
  methods: {
    handleSubmit() {
		if(!this.valid){
			return
		}
      if (this.submiting) {
        return
      }
      this.submiting = true
      this.$emit('invalidate', {})
      this.$emit('update:errors', [])
      this.submit().then(res => {
        this.submiting = false
        return res
      }).catch(error => {
        this.submiting = false
        if (error && error.response && error.response.status === 422) {
          let errorData = error.response.data.reduce((preVal, val) => {
            preVal[val.field] = val.message
            return preVal
          }, {})
          this.$emit('invalidate', errorData)
          this.$emit('update:errors', Object.values(errorData))
        }
        return error
      })
    }
  }
}
</script>